import React, { memo } from 'react';
import { createPortal } from 'react-dom';

type Props = {
	styles?: string;
	children?: string;
};

const GlobalStyles = ({ styles, children }: Props) => {
	// @ts-expect-error ts-migrate FIXME
	return createPortal(<style storycards="global-styles-component">{styles || children}</style>, document.head);
};

export default memo(GlobalStyles);
